import { createStore } from "vuex";
import mutations from "./mutations";
import getters from "./getters";
import persistedState from "vuex-persistedstate";
import SecureLS from "secure-ls";
var ls = new SecureLS({ isCompression: false });
export interface I_adminInfo {
  id: number;
  account: String;
  username: String;
  phone: String;
  roleId: number;
  roleName: String;
  status: number;
  menuAuthChildren: [];
  menuChildren: [];
}
export default createStore({
  state: {
    token: {
      accessToken: "",
      expireTime: 0,
      refreshToken: "",
    },
    adminInfo: {} as any,
    systemConfig: {} as any,
    activeMenu: [],
    systemSet: {
      activeTheme: "",
      tabFalg: true,
      logoFalg: true,
      btnAuth: false,
    },
    areaData: [] as any,
    keepAliveName: [] as any,
    isPhone: /mobile/i.test(navigator.userAgent),
    companySectorData: [
      {
        name: "互联网/AI",
        children: [
          { name: "互联网" },
          { name: "电子商务" },
          { name: "计算机软件" },
          { name: "生活服务(O2O)" },
          { name: "企业服务" },
          { name: "医疗健康" },
          { name: "游戏" },
          { name: "社交网络与媒体" },
          { name: "人工智能" },
          { name: "云计算" },
          { name: "在线教育" },
          { name: "计算机服务" },
          { name: "大数据" },
          { name: "广告营销" },
          { name: "物联网" },
          { name: "新零售" },
          { name: "信息安全" },
        ],
      },
      {
        name: "电子/通信/半导体",
        children: [
          { name: "半导体/芯片" },
          { name: "电子/硬件开发" },
          { name: "通信/网络设备" },
          { name: "智能硬件/消费电子" },
          { name: "运营商/增值服务" },
          { name: "计算机硬件" },
          { name: "电子/半导体/集成电路" },
        ],
      },
      {
        name: "服务业",
        children: [
          { name: "餐饮" },
          { name: "美容" },
          { name: "美发" },
          { name: "酒店/民宿" },
          { name: "休闲/娱乐" },
          { name: "运动/健身" },
          { name: "保健/养生" },
          { name: "家政服务" },
          { name: "旅游/景区" },
          { name: "婚庆/摄影" },
          { name: "宠物服务" },
          { name: "回收/维修" },
          { name: "美容/美发" },
          { name: "其他生活服务" },
        ],
      },
      {
        name: "消费品/批发/零售",
        children: [
          { name: "批发/零售" },
          { name: "进出口贸易" },
          { name: "食品/饮料/烟酒" },
          { name: "服装/纺织" },
          { name: "家具/家居" },
          { name: "家用电器" },
          { name: "日化" },
          { name: "珠宝/首饰" },
          { name: "家具/家电/家居" },
          { name: "其他消费品" },
        ],
      },
      {
        name: "房地产/建筑",
        children: [
          { name: "装修装饰" },
          { name: "房屋建筑工程" },
          { name: "土木工程" },
          { name: "机电工程" },
          { name: "物业管理" },
          { name: "房地产中介/租赁" },
          { name: "建筑材料" },
          { name: "房地产开发经营" },
          { name: "建筑设计" },
          { name: "建筑工程咨询服务" },
          { name: "土地与公共设施管理" },
          { name: "工程施工" },
        ],
      },
      {
        name: "教育培训",
        children: [
          { name: "培训/辅导机构" },
          { name: "职业培训" },
          { name: "学前教育" },
          { name: "学校/学历教育" },
          { name: "学术/科研" },
        ],
      },
      {
        name: "广告/传媒/文化/体育",
        children: [
          { name: "文化艺术/娱乐" },
          { name: "体育" },
          { name: "广告/公关/会展" },
          { name: "广播/影视" },
          { name: "新闻/出版" },
        ],
      },
      {
        name: "制造业",
        children: [
          { name: "通用设备" },
          { name: "专用设备" },
          { name: "电气机械/器材" },
          { name: "金属制品" },
          { name: "非金属矿物制品" },
          { name: "橡胶/塑料制品" },
          { name: "化学原料/化学制品" },
          { name: "仪器仪表" },
          { name: "自动化设备" },
          { name: "印刷/包装/造纸" },
          { name: "铁路/船舶/航空/航天制造" },
          { name: "计算机/通信/其他电子设备" },
          { name: "新材料" },
          { name: "机械设备/机电/重工" },
          { name: "仪器仪表/工业自动化" },
          { name: "原材料及加工/模具" },
          { name: "其他制造业" },
        ],
      },
      {
        name: "专业服务",
        children: [
          { name: "咨询" },
          { name: "财务/审计/税务" },
          { name: "人力资源服务" },
          { name: "法律" },
          { name: "检测/认证/知识产权" },
          { name: "翻译" },
          { name: "其他专业服务" },
        ],
      },
      {
        name: "制药/医疗",
        children: [
          { name: "医疗服务" },
          { name: "医美服务" },
          { name: "医疗器械" },
          { name: "IVD" },
          { name: "生物/制药" },
          { name: "医药批发零售" },
          { name: "医疗研发外包" },
        ],
      },
      {
        name: "汽车",
        children: [
          { name: "新能源汽车" },
          { name: "汽车智能网联" },
          { name: "汽车经销商" },
          { name: "汽车后市场" },
          { name: "汽车研发/制造" },
          { name: "汽车零部件" },
          { name: "摩托车/自行车制造" },
          { name: "4S店/后市场" },
        ],
      },
      {
        name: "交通运输/物流",
        children: [
          { name: "即时配送" },
          { name: "快递" },
          { name: "公路物流" },
          { name: "同城货运" },
          { name: "跨境物流" },
          { name: "装卸搬运和仓储业" },
          { name: "客运服务" },
          { name: "港口/铁路/公路/机场" },
          { name: "交通/运输" },
          { name: "物流/仓储" },
        ],
      },
      {
        name: "能源/化工/环保",
        children: [
          { name: "光伏" },
          { name: "储能" },
          { name: "动力电池" },
          { name: "风电" },
          { name: "其他新能源" },
          { name: "环保" },
          { name: "化工" },
          { name: "电力/热力/燃气/水利" },
          { name: "石油/石化" },
          { name: "矿产/地质" },
          { name: "采掘/冶炼" },
          { name: "新能源" },
        ],
      },
      {
        name: "金融",
        children: [
          { name: "互联网金融" },
          { name: "银行" },
          { name: "投资/融资" },
          { name: "证券/期货" },
          { name: "基金" },
          { name: "保险" },
          { name: "租赁/拍卖/典当/担保" },
          { name: "信托" },
          { name: "财富管理" },
          { name: "其他金融业" },
        ],
      },
      {
        name: "政府/非盈利机构/其他",
        children: [
          { name: "互联网/AI" },
          { name: "农/林/牧/渔" },
          { name: "非盈利机构" },
          { name: "政府/公共事业" },
          { name: "其他行业" },
        ],
      },
    ] as any,
  },
  mutations,
  actions: {},
  getters,
  plugins: [
    persistedState({
      storage: {
        setItem: (key, value) => ls.set(key, value),
        getItem: (key) => ls.get(key),
        removeItem: (key) => ls.remove(key),
      },
    }),
  ],
});
